/**
 * Created by Jonas Wålekvist on 2018-06-26.
 */
import {OldEmitterConfig} from "pixi-particles";

export class TrueGritParticleConfig {

    public static rockParticleConfig:OldEmitterConfig = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 1.5,
            "end" : 1.5,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 2500,
            "end" : 0,
            "minimumSpeedMultiplier" : 0.4
        },
        "acceleration" : {
            "x" : 0,
            "y" : 3000
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -90,
            "max" : -90
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -200,
            "max" : 200
        },
        "lifetime" : {
            "min" : 1.7,
            "max" : 1.7
        },
        "blendMode" : "normal",
        "frequency" : 0.003,
        "emitterLifetime" : 0.1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : 720,
            "h" : 0
        }
    };
    public static emberParticleConfig:OldEmitterConfig = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 1,
            "end" : 0.8,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 300,
            "end" : 500,
            "minimumSpeedMultiplier" : 0.8
        },
        "acceleration" : {
            "x" : 20,
            "y" : -40
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 115,
            "max" : 90
        },
        "noRotation" : true,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 0
        },
        "lifetime" : {
            "min" : 4,
            "max" : 4
        },
        "blendMode" : "normal",
        "frequency" : 0.3,
        "emitterLifetime" : 1,
        "maxParticles" : 100,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : 720,
            "h" : 0
        }
    };
    public static idleParticleConfig:OldEmitterConfig = {
        "alpha" : {
            "start" : 1,
            "end" : 0.8
        },
        "scale" : {
            "start" : 0.8,
            "end" : 0.0,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffd151",
            "end" : "#d19600"
        },
        "speed" : {
            "start" : 90,
            "end" : 0,
            "minimumSpeedMultiplier" : 0.5
        },
        "acceleration" : {
            "x" : 4,
            "y" : 1
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -150,
            "max" : -130
        },
        "noRotation" : true,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 0
        },
        "lifetime" : {
            "min" : 12,
            "max" : 17
        },
        "blendMode" : "add",
        "frequency" : 0.5,
        "emitterLifetime" : -1,
        "maxParticles" : 50,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 420,
            "y" : 0,
            "w" : 300,
            "h" : 0
        }
    };
    public static winDisplayParticleConfig:OldEmitterConfig = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.2,
            "end" : 0.2,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 1200,
            "end" : 1200,
            "minimumSpeedMultiplier" : 0.8
        },
        "acceleration" : {
            "x" : 0,
            "y" : 3000
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -110,
            "max" : -70
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -400,
            "max" : 400
        },
        "lifetime" : {
            "min" : 2.1,
            "max" : 2.1
        },
        "blendMode" : "normal",
        "frequency" : 0.008,
        "emitterLifetime" : 0.1,
        "maxParticles" : 50,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -100,
            "y" : -25,
            "w" : 200,
            "h" : 50
        }
    };

    public static leftBigWinParticleConfigs:OldEmitterConfig[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.2,
                "end" : 0.2,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -75,
                "max" : -80
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -100,
                "max" : 100
            },
            "lifetime" : {
                "min" : 2.1,
                "max" : 2.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : 720,// 840,
                "h" : 100//300
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.2,
                "end" : 0.2,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -75,
                "max" : -80
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -100,
                "max" : 100
            },
            "lifetime" : {
                "min" : 2.1,
                "max" : 2.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : 720,// 840,
                "h" : 100//300
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.2,
                "end" : 0.2,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -75,
                "max" : -80
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -100,
                "max" : 100
            },
            "lifetime" : {
                "min" : 2.1,
                "max" : 2.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : 720,// 840,
                "h" : 100//300
            }
        }
    ];
    public static rightBigWinParticleConfigs:OldEmitterConfig[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.2,
                "end" : 0.2,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -100,
                "max" : -105
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -100,
                "max" : 100
            },
            "lifetime" : {
                "min" : 2.1,
                "max" : 2.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : -720,//-840,
                "h" : 100//300
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.2,
                "end" : 0.2,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -100,
                "max" : -105
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -100,
                "max" : 100
            },
            "lifetime" : {
                "min" : 2.1,
                "max" : 2.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : -720,//-840,
                "h" : 100//300
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.2,
                "end" : 0.2,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 1300,
                "end" : 1300,
                "minimumSpeedMultiplier" : 0.55
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1100
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : -100,
                "max" : -105
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : -100,
                "max" : 100
            },
            "lifetime" : {
                "min" : 2.1,
                "max" : 2.1
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.1,
            "maxParticles" : 15,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : 0,
                "y" : 0,
                "w" : -720,//-840,
                "h" : 100//300
            }
        }
    ];

    public static rainConfig: OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 0.9
        },
        "scale": {
            "start": 1,
            "end": 1,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 1500,
            "end": 2000,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 90,
            "max": 90
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 0
        },
        "lifetime": {
            "min": 0.81,
            "max": 0.81
        },
        "blendMode": "add",
        "frequency": 0.004,
        "emitterLifetime": -1,
        "maxParticles": 2000,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -360,
            "y": -360,
            "w": 1280,
            "h": 20
        }
    };
    public static backgroundConfig0:any = {
        "alpha" : {
            "start" : 0.1,
            "end" : 0.2
        },
        "scale" : {
            "start" : 0.1,
            "end" : 0.2,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 50,
            "end" : 60,
            "minimumSpeedMultiplier" : 0.5
        },
        "acceleration" : {
            "x" : 100,
            "y" : 170
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 500
        },
        "lifetime" : {
            "min" : 4,
            "max" : 8
        },
        "blendMode" : "add",
        "frequency" : 0.01,
        "emitterLifetime" : -1,
        "maxParticles" : 1000,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 1,
            "y" : 1,
            "w" : 1,
            "h" : 1
        }
    };
    public static backgroundConfig1:any = {
        "alpha" : {
            "start" : 0.7,
            "end" : 1
        },
        "scale" : {
            "start" : 0.2,
            "end" : 0.4,
            "minimumScaleMultiplier" : 1
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 90,
            "end" : 150,
            "minimumSpeedMultiplier" : 1
        },
        "acceleration" : {
            "x" : 10,
            "y" : 190
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 360
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 1000
        },
        "lifetime" : {
            "min" : 4,
            "max" : 8
        },
        "blendMode" : "add",
        "frequency" : 0.08,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : 720,
            "h" : 1
        }
    };
    public static snowConfig: OldEmitterConfig = {
        "alpha": {
            "start": 0.85,
            "end": 0.65
        },
        "scale": {
            "start": 0.15,
            "end": 0.2,
            "minimumScaleMultiplier": 0.5
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 200,
            "end": 200,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 70,
            "max": 90
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 200
        },
        "lifetime": {
            "min": 4,
            "max": 4
        },
        "blendMode": "add",
        "ease": [
            {
                "s": 0,
                "cp": 0.379,
                "e": 0.548
            },
            {
                "s": 0.548,
                "cp": 0.717,
                "e": 0.676
            },
            {
                "s": 0.676,
                "cp": 0.635,
                "e": 1
            }
        ],
        "frequency": 0.004,
        "emitterLifetime": -1,
        "maxParticles": 1000,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": -360,
            "y": -360,
            "w": 1680,
            "h": 1680
        }
    };
}